<template>
    <div class="flex flex-col gap-4">
        <div v-for="(item, idx) in inferences" :key="idx" class="flex gap-4">
            <div class="grow">
                <p class="nadia-chat-bold">{{ item.profile_question_key }}</p>
                <p class="text-ink-muted body-small">{{ item.value }}</p>
            </div>
            <BaseButton
                v-if="!hideForgetButton"
                theme="ghost"
                icon-only
                :aria-label="t('chat.actions.profileInferences.remove', { name: item.profile_question_key })"
                :title="t('chat.actions.profileInferences.remove', { name: item.profile_question_key })"
                @click="forgetInference(idx)">
                <i class="bi bi-trash" aria-hidden="true" />
            </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { inject } from "vue";
import { useI18n } from "vue-i18n";

import type { UserProfileData } from "./types/profile";
import { logUserInteraction } from "./utils/logUtils";

const { t } = useI18n();
const coachingSessionUuid = inject<string>("coachingSessionUuid");

type ChatActionProfileInferencesProp = {
    inferences?: UserProfileData[];
    hideForgetButton?: boolean;
};

const { inferences = [], hideForgetButton = false } = defineProps<ChatActionProfileInferencesProp>();

const emit = defineEmits<{
    "forget-inference": [{ id: number }];
}>();

function forgetInference(inferenceIndex: number) {
    const inference = inferences[inferenceIndex];
    emit("forget-inference", { id: inference.id });
    logUserInteraction("forget_inference", { inference }, coachingSessionUuid);
}
</script>
